import { _ as ve } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.array.concat-d1c9b847.js";
import "./focusTrap.js";
import { _ as fe } from "./export-cdcbfb2b.js";
import { n as Me } from "./es.parse-int-d7709701.js";
import "./es.object.assign-7e79fd7b.js";
import { fpds as f } from "@ucl/shared-component-foundations";
import { c as o } from "./index-8b07dec9.js";
import { useState as P, useRef as b, useEffect as W } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as he } from "./getMetrics-953aa4f8.js";
import { Badge as R } from "./badge.js";
import { a as p } from "./index-5d0f31c6.js";
import { P as Ie, a as Pe } from "./popupTip-06ee114c.js";
import k, { css as g } from "styled-components";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { jsx as n, jsxs as K } from "react/jsx-runtime";
import "./es.object.keys-9d66766f.js";
import "./es.array.join-c1bca812.js";
import "./es.parse-float-020a2ae0.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./web.set-timeout-72b6430f.js";
import { uniqueId as be } from "./uniqueId.js";
import { Button as J } from "./button.js";
var ye = fe, X = Me;
ye({ target: "Number", stat: !0, forced: Number.parseInt !== X }, {
  parseInt: X
});
var ke = /* @__PURE__ */ k(J).withConfig({
  displayName: "mapMarkerstyles__POIButton",
  componentId: "jwo2bq-0"
})(["&.POIButton{", ";}"], function(u) {
  var e = u.theme.components.mapMarker;
  return g(e.POIButton);
}), ge = /* @__PURE__ */ k(J).withConfig({
  displayName: "mapMarkerstyles__PinButton",
  componentId: "jwo2bq-1"
})(["&.PinButton{", ";}"], function(u) {
  var e = u.theme.components.mapMarker;
  return g(e.PinButton);
}), Be = /* @__PURE__ */ k(Ie).withConfig({
  displayName: "mapMarkerstyles__PopupTipWrapper",
  componentId: "jwo2bq-2"
})(["&.MapMarker{", ";}"], function(u) {
  var e = u.theme.components.mapMarker;
  return g(e.PopupTipWrapper);
}), _e = ["type", "badge", "selected", "interactionType", "showMinimized", "color", "header", "subtitle", "body", "showButton", "CTAButtonLabel", "CTAButtonHandler", "accessibilityOptions", "onSelectionChange", "id"], y = "MapMarker", G = /* @__PURE__ */ n(p, {
  icon: "pinEmpty",
  width: f.semantic.size["8x"],
  height: f.semantic.size["12x"]
}), Ne = /* @__PURE__ */ n(p, {
  icon: "pinDot",
  width: f.semantic.size["8x"],
  height: f.semantic.size["12x"]
}), at = function(e) {
  var d = e.type, t = e.badge, B = e.selected, M = B === void 0 ? !1 : B, _ = e.interactionType, c = _ === void 0 ? "click" : _, N = e.showMinimized, h = N === void 0 ? !1 : N, T = e.color, Q = T === void 0 ? "default" : T, U = e.header, V = e.subtitle, Y = e.body, C = e.showButton, Z = C === void 0 ? !1 : C, ee = e.CTAButtonLabel, te = e.CTAButtonHandler, re = e.accessibilityOptions, w = e.onSelectionChange, O = e.id, H = ve(e, _e), S = P(M), s = S[0], x = S[1], z = P(!1), D = z[0], j = z[1], ne = he({
    label: y + " " + d
  }), oe = b(be(y)), I = O || oe.current, ie = H["aria-label"] || y + " " + d, ae = d === "poi", v = h && ae, A = P(v), l = A[0], se = A[1], L = b(null), m = c === "click", i = h && m && !s, E = b(!0);
  W(function() {
    var r = m ? s : D;
    se(v || r);
  }, [s, D, c, h, l, m, v]), W(function() {
    if (E.current) {
      E.current = !1;
      return;
    }
    if (i && l || !l) {
      var r;
      m && ((r = document.getElementById(I)) == null || r.focus());
    }
  }, [I, m, l, i]);
  var q = function() {
    w == null || w(!s), x(function(a) {
      return !a;
    });
  }, pe = function(a) {
    if (!a && (x(!1), v)) {
      var $;
      ($ = L.current) == null || $.open();
    }
  }, ue = function(a) {
    a.preventDefault(), q();
  }, ce = function(a) {
    (a.key === "Enter" || a.key === " ") && (a.preventDefault(), q());
  }, le = function() {
    return !t && t !== 0 ? /* @__PURE__ */ n("div", {
      className: o(["PinInsert__position_relative"]),
      children: Ne
    }) : typeof t == "number" || typeof t == "string" && !Number.isNaN(Number.parseInt(t)) ? /* @__PURE__ */ K("div", {
      className: o(["PinInsert__position_relative"]),
      children: [G, /* @__PURE__ */ n(R, {
        size: "large",
        value: "" + t,
        className: o(["PinInsert__position-absolute", "MapMarker__Insert_transparent"])
      })]
    }) : /* @__PURE__ */ K("div", {
      className: o(["PinInsert__position_relative"]),
      children: [G, /* @__PURE__ */ n(p, {
        icon: typeof t == "string" ? p.Names.includes(t) ? t : "fpo" : t,
        size: "m",
        className: o(["PinInsert__position-absolute", "MapMarker__Insert_transparent"])
      })]
    });
  }, me = function() {
    return !t && t !== 0 ? /* @__PURE__ */ n(p, {
      icon: "fpo"
    }) : typeof t == "number" || typeof t == "string" && !Number.isNaN(Number.parseInt(t)) ? /* @__PURE__ */ n(R, {
      size: "large",
      value: t,
      className: o(["PoiInsert--badge-centered", "MapMarker__Insert_transparent"])
    }) : /* @__PURE__ */ n(p, {
      icon: typeof t == "string" ? p.Names.includes(t) ? t : "fpo" : t,
      className: o(["PoiInsert", "MapMarker__Insert_transparent"])
    });
  }, F = {
    id: I,
    onClick: ue,
    onKeyDown: ce,
    onMouseEnter: function() {
      c === "hover" && j(!0);
    },
    onMouseLeave: function() {
      c === "hover" && j(!1);
    }
  }, de = d === "pin" ? /* @__PURE__ */ n(ge, Object.assign({
    autoFocus: M,
    className: o(["PinButton", "PinButton--default", {
      "PinButton--selected": s
    }])
  }, F, {
    children: le()
  })) : /* @__PURE__ */ n(ke, Object.assign({
    autoFocus: M,
    className: o(["POIButton", "POIButton--" + Q, {
      "POIButton--selected": s
    }])
  }, F, {
    leftIcon: me()
  }));
  return /* @__PURE__ */ n(Be, Object.assign({
    placement: Pe.TOP,
    isPlacementFixed: !0,
    hideTitleDivider: !0,
    open: l,
    popupTipHeader: U,
    popupTipHeaderSubtitle: V,
    popupTipBody: !i && Y,
    showButton: !i && Z,
    CTAButtonLabel: i ? "" : ee,
    CTAButtonHandler: i ? void 0 : te,
    accessibilityOptions: re,
    neverCloseOnClickOutside: i,
    onChange: pe,
    "aria-label": ie,
    className: o(["MapMarker", "MapMarker--restrict-clicks", "MapMarker--" + (i ? "minimised" : "complex"), {
      "MapMarker--highlight-bg-onHover": !s,
      "MapMarker--interactionType-hover": c === "hover"
    }])
  }, ne, H, {
    ref: L,
    children: de
  }), O + "-popupTip-" + i);
};
export {
  at as M
};
